<div class="p-4 w-full flex flex-col pt-12">
  <!-- Botón Volver con SVG manual para asegurar dirección < -->
  <div class="mb-4">
    <button (click)="goBack()"
      class="w-10 h-10 flex items-center justify-center hover:bg-gray-100 rounded-full transition-all text-gray-600">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M5 12l14 0" />
        <path d="M5 12l4 4" />
        <path d="M5 12l4 -4" />
      </svg>
    </button>
  </div>

  @if (isLoading) {
    <div class="flex justify-center py-20">
      <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-metro-blue"></div>
    </div>
  } @else if (error) {
    <div class="text-center py-20 bg-white p-6 rounded-xl shadow-sm border border-gray-100 w-full">
      <p class="text-red-500 font-medium">{{ error }}</p>
      <button (click)="goBack()" class="mt-4 text-metro-blue font-bold hover:underline">
        {{ '::GoBack' | abpLocalization }}
      </button>
    </div>
  } @else if (order) {
    <div class="bg-white p-6 md:p-12 rounded-xl shadow-sm border border-gray-100 w-full">
      <!-- Título de Orden -->
      <div class="mb-6">
        <h1 class="text-2xl font-bold text-gray-900 leading-tight mb-2">Detalle de Orden</h1>
        <h2 class="text-lg text-metro-blue-secondary font-bold tracking-wide">
          {{ '::Order' | abpLocalization }} #{{ order.id }}
        </h2>
      </div>

      <!-- Products -->
      <div class="space-y-4 mb-8">
        @for (item of order.orderItems; track $index) {
          <div class="flex items-center gap-4">
            <div class="w-14 h-14 flex items-center justify-center flex-shrink-0">
              <img [src]="item.wine?.imageUrl || 'assets/images/no-image.png'"
                class="max-w-full max-h-full object-contain rounded-lg" [alt]="item.wineName || item.wine?.name || ''"
                onerror="this.src='assets/images/no-image.png'">
            </div>

            <div>
              <div class="font-semibold text-gray-900">{{ item.wineName || item.wine?.name || '' }}</div>
              <div class="text-metro-blue text-sm">
                {{ item.quantity }} {{ item.quantity > 1 ? ('::Bottles' | abpLocalization) : ('::Bottle' | abpLocalization) }}
              </div>
            </div>
          </div>
        }
      </div>

      <!-- Información de Orden -->
      <div>
        <h3 class="font-bold text-lg text-gray-800 mb-3">{{ '::OrderInfo' | abpLocalization }}</h3>
        <div class="border-t border-gray-100">
          <div class="py-3 border-b border-gray-100">
            <div class="text-metro-blue text-sm">{{ '::Date' | abpLocalization }}</div>
            <div class="font-medium text-gray-900">{{ order.creationTime | date:'dd/MM/yyyy' }}</div>
          </div>
          <div class="py-3 border-b border-gray-100">
            <div class="text-metro-blue text-sm">{{ '::Status' | abpLocalization }}</div>
            <div class="font-medium text-gray-900">{{ '::' + getOrderStatusString(order.orderStatus) | abpLocalization }}</div>
          </div>
          <div class="py-3 border-b border-gray-100">
            <div class="text-metro-blue text-sm">{{ '::PaymentMethod' | abpLocalization }}</div>
            <div class="font-medium text-gray-900">{{ order.paymentMethod || ('::NotSpecified' | abpLocalization) }}</div>
          </div>
          @if (order.priceListName) {
          <div class="py-3 border-b border-gray-100">
            <div class="text-metro-blue text-sm">{{ '::PriceList' | abpLocalization }}</div>
            <div class="font-medium text-gray-900">{{ order.priceListName }}</div>
          </div>
          }
          <div class="py-3 border-b border-gray-100">
            <div class="text-metro-blue text-sm">{{ '::Name' | abpLocalization }}</div>
            <div class="font-medium text-gray-900">{{ order.userName }} {{ order.userSurname }}</div>
          </div>
          
          <!-- Desglose de importes -->
          <div class="py-3 border-b border-gray-100">
            <div class="text-metro-blue text-sm">{{ '::SubTotal' | abpLocalization }}</div>
            <div class="font-medium text-gray-900">${{ order.subTotal | number:'1.2-2' }}</div>
          </div>

          <div class="py-3 border-b border-gray-100">
            <div class="text-metro-blue text-sm">{{ '::Tax' | abpLocalization }} 21%</div>
            <div class="font-medium text-gray-900">${{ order.tax | number:'1.2-2' }}</div>
          </div>

          @if (order.couponCode) {
            <div class="py-3 border-b border-gray-100">
              <div class="text-metro-blue text-sm">{{ '::Discount' | abpLocalization }} ({{ order.couponCode }})</div>
              <div class="font-medium text-red-500">-${{ order.couponDiscountAmount | number:'1.2-2' }}</div>
            </div>
          }

          @if (order.interestCharge > 0) {
            <div class="py-3 border-b border-gray-100">
              <div class="text-metro-blue text-sm">{{ '::InterestCharge' | abpLocalization }}</div>
              <div class="font-medium text-gray-900">${{ order.interestCharge | number:'1.2-2' }}</div>
            </div>
          }

          <div class="py-3">
            <div class="text-metro-blue text-sm">{{ '::Total' | abpLocalization }}</div>
            <div class="font-bold text-lg text-metro-blue-secondary">${{ order.total | number:'1.2-2' }}</div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
